module.exports = __webpack_public_path__ + "static/step3-ea3caa5e93b519675ddb50c53b4082f0.svg";